import './Channel.less';
export { default as Channel } from './Channel.js';
export { default } from './Channel.js';